// WS8 WS-5 — query-key factory for the TPS surface. Lives in its own *Keys
// file so the stale-after-save convention recognises it (gate skips files
// matching /[Kk]eys\.tsx?$/) and mutations can invalidate by prefix.

import type { QueryKey } from "@tanstack/react-query";
import type { TpsListQuery } from "@/types/tps";

export const tpsKeys = {
  all: ["tps"] as const,
  list: (query: TpsListQuery | undefined) =>
    ["tps", "list", query ?? {}] as QueryKey,
  detail: (id: string) => ["tps", "detail", id] as const,
  default: ["tps", "default"] as const,
  // SP-3 — setup checklist + batched picker readiness.
  setup: (id: string) => ["tps", "setup", id] as const,
  readiness: ["tps", "readiness"] as const,
  // Portal absorption (WS-D2) — the linked-portal-account reverse lookup.
  portalAccount: (id: string) => ["tps", "portal-account", id] as const,
};

// LegalEntity reads used by the TPS surface (picker + detail header). Kept
// here (not in counterpartyKeys.ts) so the stale-after-save gate sees the
// keys in a *Keys file without forcing a cross-cutting migration of the
// other grandfathered callers (NewInvestorModal, NewProviderModal,
// ServiceProviderDetailPage, useInvestorName).
export const tpsEntityKeys = {
  picker: ["counterparties", "entities", "picker"] as const,
  detail: (entityId: string | undefined) =>
    ["counterparties", "entity", entityId] as const,
};
